module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAArElEQVRoge3ZIQ4CURAE0Qp3gMD9b4IhARQIjrMIHGpn2B5B6vlKpr/9IOlXZ+AOHMJN3BVYgCfrD+s0cXvgweewF3AKNSMc02hGOKbRjHBMoxnhmEYzwjGNZoRjGs0IxzSaEY5pNCMcs7bZbXBg1zLUbOr7ZY+hJsoRhSbKEYUmyhGFJsoRhSbKEYUmyhGFJsoRhSbKEYUm6i9GANyofzV3mrgL9c//TiMp6A1f2OUdfUmfJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/dbright.png
// module id = oS2K
// module chunks = 4